import { ActiveCartGiftWithPurchases } from 'types/cart';
import { getSizesFromSizeGroups } from 'utils/products';
import { Size, VariantProduct } from '__generated__/graphql';

export const findSizeObject = (
  item: VariantProduct,
  giftWithPurchase?: ActiveCartGiftWithPurchases
): Size => {
  const availableProducts = giftWithPurchase?.availableProducts?.map(a => {
    if ('id' in a) return a;
    if ('product' in a) return a.product;
    return undefined;
  });

  const product = availableProducts?.find(p => {
    let size = false;
    if (p && 'styleNumber' in p) {
      // p is VariantProduct
      size = p.styleNumber === item.styleNumber;
    }
    if (p && 'variations' in p) {
      // p is Product
      size = !!p.variations.find(v => v.id === item.styleNumber);
    }
    return size;
  });

  let sizeVariant;
  if (product && 'styleNumber' in product) {
    // product is VariantProduct
    sizeVariant = product.size;
  }
  if (product && 'variations' in product) {
    // product is Product
    const matchingVariant = product.variations.find(
      v => v.id === item.styleNumber
    );
    const sizes = matchingVariant
      ? getSizesFromSizeGroups(matchingVariant.sizeGroups)
      : [];
    const sizeFound = sizes.find(s => s.id === item.size.value);
    if (sizeFound) sizeVariant = sizeFound;
  }
  return sizeVariant;
};
